import { render, staticRenderFns } from "./RealEstateSocialPosting.vue?vue&type=template&id=f8eb63ae"
import script from "./RealEstateSocialPosting.vue?vue&type=script&lang=ts"
export * from "./RealEstateSocialPosting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports